// Centralized Publications page content for different WCHSS years.

export const publicationsContent2026 = {
  introParagraphs: [
    'Selected papers presented at WCHSS 2026 will have opportunities to be published in conference proceedings and partner journals. All submissions will undergo peer-review and editorial evaluation based on academic quality, originality, relevance, and scientific contribution.',
    'Accepted papers may be recommended for publication in indexed proceedings and selected national or international journals according to publication requirements and editorial policies.',
  ],
  opportunitiesTitle: 'Publication Opportunities',
  opportunities: [
    'Atlantis Press Proceedings (AHSR / ASSEHR Series)',
    'Indexed International Proceedings',
    'National Accredited Journals (SINTA 4)',
    'National Accredited Journals (SINTA 5)',
    'Health and Social Science Journals',
    'Nursing and Midwifery Journals',
    'Public Health Journals',
    'Interdisciplinary Health Research Journals',
  ],
  proceedingsTitle: 'Proceedings',
  proceedingsItems: [
    'Atlantis Press Proceedings',
    'WCHSS 2026 Conference Proceedings',
    'Selected peer-reviewed conference papers',
  ],
  additionalNotesTitle: 'Additional Notes',
  additionalNotes: [
    'Publication opportunities depend on reviewer and editorial decisions',
    'Authors must comply with publication formatting and ethical guidelines',
    'Additional publication fees may apply depending on journal policy',
  ],
};
